export default "__VITE_ASSET__0f9254db__"